<template>
  <b-card no-body>
    <b-card-header>网站信息</b-card-header>
    <b-card-body class="row">
      <div class="container">
        <b-form-group label="网站名称">
          <b-form-input v-model="g_config.site_name"></b-form-input>
        </b-form-group>
        <b-form-group label="网站图标">
          <b-form-input v-model="g_config.site_icon" type="url"></b-form-input>
          <b-form-text>示例：https://example.com/favicon.png</b-form-text>
        </b-form-group>
        <b-form-group label="网站标题">
          <b-form-input v-model="g_config.site_title"></b-form-input>
        </b-form-group>
        <b-form-group label="网站关键字">
          <b-form-input v-model="g_config.site_keywords"></b-form-input>
        </b-form-group>

        <b-form-group label="网站描述">
          <b-form-textarea rows="3" v-model="g_config.site_description"></b-form-textarea>
        </b-form-group>

        <b-form-group label="全站脚本">
          <b-form-textarea rows="3" v-model="g_config.site_script"></b-form-textarea>
          <b-form-text>示例：&lt;script&gt;console.log('js');&lt;/script&gt;</b-form-text>
        </b-form-group>

        <b-form-group label="网站公告">
          <b-form-textarea rows="10" max-rows="50" v-model="g_config.site_readme"></b-form-textarea>
          <b-form-text>markdown格式</b-form-text>
        </b-form-group>
        <b-button
          href="#"
          variant="primary"
          :disabled="waiting"
          style="min-width: 80px;"
          @click="save"
        >{{waiting?"提交中":"保存"}}</b-button>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  data() {
    return {
      waiting: false,
      g_config: {
        site_name: "xx",
        site_icon: "xx",
        site_title: "xx",
        site_keywords: "xx",
        site_description: "xx",
        site_script: "xx",
        site_readme: "xx"
      }
    };
  },
  created: function() {
    let _this = this;
    this.common.axios
      .get("./admin/ajax/setting/site")
      .then(res => {
        _this.g_config = res.data.G_CONFIG;
      })
      .catch(err => {
        _this.g_config.site_name = "error: " + err.message;
      });
  },
  methods: {
    save() {
      let _this = this;
      this.waiting = true;
      this.common.axios
        .post("./admin/ajax/save", { G_CONFIG: this.g_config })
        .then(r => {
          _this.waiting = false;
          alert(r.data.info);
        })
        .catch(e => {
          _this.waiting = false;
          console.log(e);
          alert("failed");
        });
    }
  }
};
</script>